import AccountTree from '@mui/icons-material/AccountTreeOutlined'
import Debug from '@mui/icons-material/AdbOutlined'
import ChartData from '@mui/icons-material/AddchartOutlined'
import Add from '@mui/icons-material/AddOutlined'
import { default as SwitchOff, default as SwitchOn } from '@mui/icons-material/AlbumOutlined'
import ArrowDropDown from '@mui/icons-material/ArrowDropDownOutlined'
import ArrowRight from '@mui/icons-material/ArrowRightOutlined'
import Page from '@mui/icons-material/Article'
import Daw from '@mui/icons-material/ArtTrackOutlined'
import Resize from '@mui/icons-material/AspectRatioOutlined'
import Analyze from '@mui/icons-material/AssessmentOutlined'
import Pool from '@mui/icons-material/AudiotrackOutlined'
import PollResults from '@mui/icons-material/BallotOutlined'
import Chart from '@mui/icons-material/BarChartOutlined'
import Labs from '@mui/icons-material/BuildOutlined'
import Calendar from '@mui/icons-material/CalendarMonth'
import CalendarEvent from '@mui/icons-material/CalendarToday'
import CameraFront from '@mui/icons-material/CameraFront'
import CameraRear from '@mui/icons-material/CameraRear'
import Cancel from '@mui/icons-material/CancelOutlined'
import PresentOff from '@mui/icons-material/CancelPresentationOutlined'
import Context from '@mui/icons-material/CenterFocusStrong'
import Chat from '@mui/icons-material/ChatBubble'
import Todo from '@mui/icons-material/CheckBoxOutlined'
import Check from '@mui/icons-material/CheckOutlined'
import Left from '@mui/icons-material/ChevronLeftOutlined'
import Right from '@mui/icons-material/ChevronRightOutlined'
import Close from '@mui/icons-material/CloseOutlined'
import Offline from '@mui/icons-material/CloudOffOutlined'
import Online from '@mui/icons-material/CloudOutlined'
import Gallery from '@mui/icons-material/CollectionsOutlined'
import Block from '@mui/icons-material/Crop169Outlined'
import Delete from '@mui/icons-material/DeleteOutlined'
import Fail from '@mui/icons-material/DoDisturbOutlined'
import Download from '@mui/icons-material/DownloadOutlined'
import DragHandle from '@mui/icons-material/DragHandleOutlined'
import DragIndicator from '@mui/icons-material/DragIndicatorOutlined'
import Rename from '@mui/icons-material/DriveFileRenameOutline'
import Edit from '@mui/icons-material/EditOutlined'
import Tool from '@mui/icons-material/HandymanOutlined'
import Eject from '@mui/icons-material/EjectOutlined'
import Emoji from '@mui/icons-material/EmojiEmotionsOutlined'
import ErrorOutline from '@mui/icons-material/ErrorOutlineOutlined'
import Exit from '@mui/icons-material/ExitToAppOutlined'
import ExpandLess from '@mui/icons-material/ExpandLessOutlined'
import ExpandMore from '@mui/icons-material/ExpandMoreOutlined'
import Favorite from '@mui/icons-material/FavoriteOutlined'
import FavoriteBorder from '@mui/icons-material/FavoriteBorder'
import { default as Record, default as RecordOff } from '@mui/icons-material/FiberManualRecordOutlined'
import Copy from '@mui/icons-material/FileCopyOutlined'
import Folder from '@mui/icons-material/Folder'
import FolderOpen from '@mui/icons-material/FolderOpen'
import FormatAlignCenter from '@mui/icons-material/FormatAlignCenterOutlined'
import FormatAlignJustify from '@mui/icons-material/FormatAlignJustifyOutlined'
import FormatAlignLeft from '@mui/icons-material/FormatAlignLeftOutlined'
import FormatAlignRight from '@mui/icons-material/FormatAlignRightOutlined'
import Bold from '@mui/icons-material/FormatBoldOutlined'
import Italic from '@mui/icons-material/FormatItalicOutlined'
import Strikethrough from '@mui/icons-material/FormatStrikethroughOutlined'
import Underlined from '@mui/icons-material/FormatUnderlinedOutlined'
import FullScreenExit from '@mui/icons-material/FullscreenExitOutlined'
import FullScreen from '@mui/icons-material/FullscreenOutlined'
import Functions from '@mui/icons-material/FunctionsOutlined'
import Game from '@mui/icons-material/GamesOutlined'
import Drawing from '@mui/icons-material/GestureOutlined'
import Audio from '@mui/icons-material/GraphicEq'
import Fretboard from '@mui/icons-material/Grid4x4'
import GridView from '@mui/icons-material/GridViewOutlined'
import Band from '@mui/icons-material/Groups'
import Collaboration from '@mui/icons-material/GroupWorkOutlined'
import Headset from '@mui/icons-material/HeadsetOutlined'
import Help from '@mui/icons-material/HelpOutline'
import Home from '@mui/icons-material/Home'
import Divider from '@mui/icons-material/HorizontalSplitOutlined'
import PollFinalOption from '@mui/icons-material/HowToRegOutlined'
import Image from '@mui/icons-material/Image'
import Info from '@mui/icons-material/InfoOutlined'
import Prev from '@mui/icons-material/KeyboardArrowLeftOutlined'
import Next from '@mui/icons-material/KeyboardArrowRightOutlined'
import Launch from '@mui/icons-material/LaunchOutlined'
import { default as LibraryMusic, default as MuscialScore } from '@mui/icons-material/LibraryMusicOutlined'
import Suggestion from '@mui/icons-material/Lightbulb'
import Link from '@mui/icons-material/LinkOutlined'
import Schema from '@mui/icons-material/ListAltOutlined'
import Song from '@mui/icons-material/Lyrics'
import MeetingRoom from '@mui/icons-material/MeetingRoomOutlined'
import MenuOpen from '@mui/icons-material/MenuOpenOutlined'
import Menu from '@mui/icons-material/MenuOutlined'
import Microphone from '@mui/icons-material/MicNoneOutlined'
import MicOff from '@mui/icons-material/MicOffOutlined'
import MoreVertIcon from '@mui/icons-material/MoreVertOutlined'
import Move from '@mui/icons-material/MoveUpOutlined'
import MusicNote from '@mui/icons-material/MusicNote'
import Note from '@mui/icons-material/NoteAlt'
import AccessDenied from '@mui/icons-material/NotInterested'
import Embed from '@mui/icons-material/OpenInBrowserOutlined'
import OpenLink from '@mui/icons-material/OpenInNewOutlined'
import Pause from '@mui/icons-material/PauseOutlined'
import Play from '@mui/icons-material/PlayArrow'
import Transpose from '@mui/icons-material/PlusOneOutlined'
import Poll from '@mui/icons-material/PollOutlined'
import Present from '@mui/icons-material/PresentToAllOutlined'
import Print from '@mui/icons-material/PrintOutlined'
import Brain from '@mui/icons-material/PsychologyOutlined'
import Question from '@mui/icons-material/QuestionMarkOutlined'
import PlayList from '@mui/icons-material/QueueMusic'
import Compose from '@mui/icons-material/RecordVoiceOverOutlined'
import Refresh from '@mui/icons-material/RefreshOutlined'
import Remove from '@mui/icons-material/RemoveOutlined'
import RestoreFromTrash from '@mui/icons-material/RestoreFromTrashOutlined'
import Recent from '@mui/icons-material/RestoreOutlined'
import RestorePage from '@mui/icons-material/RestorePageOutlined'
import RotateLeft from '@mui/icons-material/RotateLeftOutlined'
import RotateRight from '@mui/icons-material/RotateRightOutlined'
import Save from '@mui/icons-material/SaveOutlined'
import Search from '@mui/icons-material/SearchOutlined'
import { default as Preset, default as Settings } from '@mui/icons-material/SettingsOutlined'
import Share from '@mui/icons-material/ShareOutlined'
import Performance from '@mui/icons-material/SlideshowOutlined'
import StarOutlined from '@mui/icons-material/StarBorderOutlined'
import Star from '@mui/icons-material/StarOutlined'
import Stop from '@mui/icons-material/StopOutlined'
import TableRows from '@mui/icons-material/TableRowsOutlined'
import Tag from '@mui/icons-material/TagOutlined'
import Form from '@mui/icons-material/TextFormatOutlined'
import Heading from '@mui/icons-material/TitleOutlined'
import Transcribe from '@mui/icons-material/Transcribe'
import Transform from '@mui/icons-material/TransformOutlined'
import Controls from '@mui/icons-material/TuneOutlined'
import Upload from '@mui/icons-material/UploadOutlined'
import Tuner from '@mui/icons-material/VerticalAlignCenterOutlined'
import Room from '@mui/icons-material/VideoCallOutlined'
import VideoCam from '@mui/icons-material/Videocam'
import VideoCamOff from '@mui/icons-material/VideocamOff'
import Columns from '@mui/icons-material/ViewColumnOutlined'
import Activities from '@mui/icons-material/ViewListOutlined'
import ViewSidebar from '@mui/icons-material/ViewSidebarOutlined'
import { default as Preview, default as View } from '@mui/icons-material/VisibilityOutlined'
import WebAsset from '@mui/icons-material/WebAssetOutlined'
import type { SvgIconProps, SxProps } from '@mui/material'
import { Guitar as AcousticGuitar, Drum, Guitar as ElectricGuitar, Hammer as Gear } from 'lucide-react'
import type { FC } from 'react'
import Bass from './bass.js'
import DeadFish from './dead-fish.js'
import Evernote from './evernote.js'
import GuitarTab from './guitar-tab.js'
import Instagram from './instagram.js'
import Midi from './midi.js'
import Pdf from './pdf.js'
import Effect from './pedal.js'
import Piano from './piano.js'
import Spotify from './spotify.js'
import YouTube from './youtube.js'

const Video = Room
const Pedal = Effect
const PedalIcon = Effect
const Chord = AcousticGuitar
const Guitar = ElectricGuitar
const ViewList = Activities
const Section = MuscialScore
const Mixer = Audio
const Comment = Chat
const Convert = Transform

export const icons = {
  AccessDenied,
  AccountTree,
  AcousticGuitar,
  Activities,
  Add,
  Analyze,
  ArrowDropDown,
  ArrowRight,
  Audio,
  Band,
  Bass,
  Block,
  Bold,
  Brain,
  Calendar,
  CalendarEvent,
  CameraFront,
  CameraRear,
  Cancel,
  Chart,
  ChartData,
  Chat,
  Check,
  Chord,
  Close,
  Collaboration,
  Columns,
  Comment,
  Compose,
  Context,
  Controls,
  Convert,
  Copy,
  Daw,
  DeadFish,
  Debug,
  Delete,
  Divider,
  Download,
  DragHandle,
  DragIndicator,
  Drawing,
  Drum,
  Edit,
  Effect,
  Eject,
  ElectricGuitar,
  Embed,
  Emoji,
  ErrorOutline,
  Evernote,
  Exit,
  ExpandLess,
  ExpandMore,
  Fail,
  Favorite,
  FavoriteBorder,
  Folder,
  FolderOpen,
  Form,
  FormatAlignCenter,
  FormatAlignJustify,
  FormatAlignLeft,
  FormatAlignRight,
  Fretboard,
  FullScreen,
  FullScreenExit,
  Functions,
  Gallery,
  Game,
  Gear,
  GridView,
  Guitar,
  GuitarTab,
  Heading,
  Headset,
  Help,
  Home,
  Image,
  Info,
  Instagram,
  Italic,
  Labs,
  Launch,
  Left,
  LibraryMusic,
  Link,
  MeetingRoom,
  Menu,
  MenuOpen,
  MicOff,
  Microphone,
  Midi,
  Mixer,
  MoreVertIcon,
  Move,
  MuscialScore,
  MusicNote,
  Next,
  Note,
  Offline,
  Online,
  OpenLink,
  Page,
  Pause,
  Pdf,
  Pedal,
  PedalIcon,
  Performance,
  Piano,
  Play,
  PlayList,
  Poll,
  PollFinalOption,
  PollResults,
  Pool,
  Present,
  PresentOff,
  Preset,
  Prev,
  Preview,
  Print,
  Question,
  Recent,
  Record,
  RecordOff,
  Refresh,
  Remove,
  Rename,
  Resize,
  RestoreFromTrash,
  RestorePage,
  Right,
  Room,
  RotateLeft,
  RotateRight,
  Save,
  Schema,
  Search,
  Section,
  Settings,
  Share,
  Song,
  Spotify,
  Star,
  StarOutlined,
  Stop,
  Strikethrough,
  Suggestion,
  SwitchOff,
  SwitchOn,
  TableRows,
  Tag,
  Todo,
  Transcribe,
  Transform,
  Transpose,
  Tuner,
  Underlined,
  Upload,
  Video,
  VideoCam,
  VideoCamOff,
  View,
  ViewList,
  ViewSidebar,
  WebAsset,
  YouTube,
}

export {
  AccessDenied,
  AccountTree,
  AcousticGuitar,
  Activities,
  Add,
  Analyze,
  ArrowDropDown,
  ArrowRight,
  Audio,
  Band,
  Bass,
  Block,
  Bold,
  Brain,
  Calendar,
  CalendarEvent,
  CameraFront,
  CameraRear,
  Cancel,
  Chart,
  ChartData,
  Chat,
  Check,
  Chord,
  Close,
  Collaboration,
  Columns,
  Comment,
  Compose,
  Context,
  Controls,
  Convert,
  Copy,
  Daw,
  DeadFish,
  Debug,
  Delete,
  Divider,
  Download,
  DragHandle,
  DragIndicator,
  Drawing,
  Drum,
  Edit,
  Effect,
  Eject,
  ElectricGuitar,
  Embed,
  Emoji,
  ErrorOutline,
  Evernote,
  Exit,
  ExpandLess,
  ExpandMore,
  Fail,
  Favorite,
  FavoriteBorder,
  Folder,
  FolderOpen,
  Form,
  FormatAlignCenter,
  FormatAlignJustify,
  FormatAlignLeft,
  FormatAlignRight,
  Fretboard,
  FullScreen,
  FullScreenExit,
  Functions,
  Gallery,
  Game,
  Gear,
  GridView,
  Guitar,
  GuitarTab,
  Heading,
  Headset,
  Help,
  Home,
  Image,
  Info,
  Instagram,
  Italic,
  Labs,
  Launch,
  Left,
  LibraryMusic,
  Link,
  MeetingRoom,
  Menu,
  MenuOpen,
  MicOff,
  Microphone,
  Midi,
  Mixer,
  MoreVertIcon,
  Move,
  MuscialScore,
  MusicNote,
  Next,
  Note,
  Offline,
  Online,
  OpenLink,
  Page,
  Pause,
  Pdf,
  Pedal,
  PedalIcon,
  Performance,
  Piano,
  Play,
  PlayList,
  Poll,
  PollFinalOption,
  PollResults,
  Pool,
  Present,
  PresentOff,
  Preset,
  Prev,
  Preview,
  Print,
  Question,
  Recent,
  Record,
  RecordOff,
  Refresh,
  Remove,
  Rename,
  Resize,
  RestoreFromTrash,
  RestorePage,
  Right,
  Room,
  RotateLeft,
  RotateRight,
  Save,
  Schema,
  Search,
  Section,
  Settings,
  Share,
  Song,
  Spotify,
  Star,
  StarOutlined,
  Stop,
  Strikethrough,
  Suggestion,
  SwitchOff,
  SwitchOn,
  TableRows,
  Tag,
  Todo,
  Transcribe,
  Transform,
  Transpose,
  Tuner,
  Underlined,
  Upload,
  Video,
  VideoCam,
  VideoCamOff,
  View,
  ViewList,
  ViewSidebar,
  WebAsset,
  YouTube,
  Tool,
}

export type IconName = keyof typeof icons
export const iconNames = Object.keys(icons) as IconName[]

// Export all icons

// Use one of the icons as a type template
interface IconProps extends SvgIconProps {
  sx?: SxProps
  className?: string
}

type SvgIconComponent = FC<IconProps>
export type { IconProps, SvgIconComponent }
